import React from 'react';
import { withRouter } from 'react-router-dom';

class EditarEstoque extends React.Component {

    constructor() {

        super();

        this.state = {
            disabled: false,
            centroId: 0,
            centro: "",
            id: 0,
            produto: "",
            embalagem: "",
            unidadeMedida: "",
            qtddEmbalagem: "",
            unidadesDisponiveis: 0,
            ativo: ""
        };

        this.changeProduto = this.changeProduto.bind(this);
        this.changeEmbalagem = this.changeEmbalagem.bind(this);
        this.changeUnidadeMedida = this.changeUnidadeMedida.bind(this);
        this.changeQtddEmbalagem = this.changeQtddEmbalagem.bind(this);
        this.changeAtivo = this.changeAtivo.bind(this);
        this.salvar = this.salvar.bind(this);
        this.cancelar = this.cancelar.bind(this);

    }

    desformatarValor(s) {
        if (s === null) return "";
        return s.replace(",", ".");
    }

    changeProduto(e) {
        this.setState({ produto: e.target.value });
    }

    changeEmbalagem(e) {
        this.setState({ embalagem: e.target.value });
    }

    changeUnidadeMedida(e) {
        this.setState({ unidadeMedida: e.target.value });
    }

    changeQtddEmbalagem(e) {

        let re = /^[0-9]*(,[0-9]{0,})?$/i;

        if (re.test(e.target.value)) {
            this.setState({ qtddEmbalagem: e.target.value });
        }

    }

    changeAtivo(e) {
        if (e.target.value === "ativo") this.setState({ ativo: true });
        else this.setState({ ativo: false });
    }

    salvar() {

        this.setState({ disabled: true });

        if (this.state.produto === "") {

            this.props.errMsgHandler("Por favor, informe qual é o produto que será cadastrado.");
            this.setState({ disabled: false });

        } else if (this.state.embalagem === "") {

            this.props.errMsgHandler("Por favor, informe qual é o tipo de embalagem.");
            this.setState({ disabled: false });

        } else if (this.state.unidadeMedida === "") {

            this.props.errMsgHandler("Por favor, informe qual é a unidade de medida.");
            this.setState({ disabled: false });

        } else if (this.state.qtddEmbalagem === "") {

            this.props.errMsgHandler("Por favor, informe qual é a quantidade de produto contida na embalagem.");
            this.setState({ disabled: false });

        } else {

            this.props.errMsgHandler("");
            this.props.waitMsgHandler("Aguardando");

            let obj = {
                "id": this.state.id,
                "produto": this.state.produto,
                "embalagem": this.state.embalagem,
                "unidade_medida": this.state.unidadeMedida,
                "qtdd_embalagem": this.desformatarValor(this.state.qtddEmbalagem),
                "unidades_disponiveis": this.state.unidadesDisponiveis,
                "ativo": this.state.ativo,
                "centro_id": this.state.centroId
            };

            fetch("/api/estoque/", {
                method: "PUT",
                headers: {
                    "Content-type": "application/json",
                    "Authorization": "Basic " + btoa(localStorage.auth)
                },
                mode: "cors",
                body: JSON.stringify(obj)
            })
            .then(response => response.json())
            .then(responseJson => {

                if (responseJson.msg === "success") {

                    this.props.waitMsgHandler("");
                    this.props.successMsgHandler("Informações de produto salvas com sucesso.");

                    let obj = {
                        row: {
                            id: this.state.id,
                            data: [
                                this.state.produto,
                                this.state.embalagem,
                                this.state.unidadeMedida,
                                this.state.qtddEmbalagem,
                                this.state.unidadesDisponiveis,
                                this.state.ativo
                            ]
                        }
                    };

                    this.props.history.push({
                        pathname: "/visualizarproduto",
                        state: obj
                    });

                }

            });

        }

    }

    cancelar() {

        let obj = {
            row: {
                id: this.state.id,
                data: [
                    this.state.produto,
                    this.state.embalagem,
                    this.state.unidadeMedida,
                    this.state.qtddEmbalagem,
                    this.state.unidadesDisponiveis,
                    this.state.ativo
                ]
            }
        };

        this.props.history.push({
            pathname: "/visualizarproduto",
            state: obj
        });

    }

    componentDidMount() {

        if (localStorage.roleEstoque !== "escrever") {
            window.location.href = "/home";
        }

        if (this.props.location.state === undefined) {
            window.location.href = "/estoque";
        }

        let centroId = this.props.location.state.centroId;
        let centro = this.props.location.state.centro;
        let id = this.props.location.state.id;
        let produto = this.props.location.state.produto;
        let embalagem = this.props.location.state.embalagem;
        let unidadeMedida = this.props.location.state.unidadeMedida;
        let qtddEmbalagem = this.props.location.state.qtddEmbalagem;
        let unidadesDisponiveis = this.props.location.state.unidadesDisponiveis;
        let ativo = this.props.location.state.ativo;

        this.setState({ centroId: centroId });
        this.setState({ centro: centro });
        this.setState({ id: id });
        this.setState({ produto: produto });
        this.setState({ embalagem: embalagem });
        this.setState({ unidadeMedida: unidadeMedida });
        this.setState({ qtddEmbalagem: qtddEmbalagem });
        this.setState({ unidadesDisponiveis: unidadesDisponiveis });

        if (ativo === 0) {
            this.setState({ ativo: false });
        } else {
            this.setState({ ativo: true });
        }

    }

    render() {
        return(
            <div>
                <h1 id="editar-produto-title">Editar Produto</h1><br />
                <p id="editar-produto-centro">
                    <b>Centro:</b> { this.state.centro }
                </p><br /><br />
                <form id="editar-produto-form">
                    <input type="text"
                        placeholder="Produto"
                        value={ this.state.produto }
                        onChange={ this.changeProduto } /><br />
                    <input type="text"
                        placeholder="Embalagem"
                        value={ this.state.embalagem }
                        onChange={ this.changeEmbalagem } /><br />
                    <input type="text"
                        placeholder="Unidade de Medida"
                        value={ this.state.unidadeMedida }
                        onChange={ this.changeUnidadeMedida } /><br /><br />
                    <span Class="edproduto-somente-numeros">
                        (Somente valores númericos no campo abaixo. Ex: 10, 1,5, ...)
                    </span><br /><br />
                    <span Class="edproduto-somente-numeros">
                        (Utilize vírgula (,) para separar a parte inteira da parte decimal.)
                    </span><br /><br />
                    <input type="text"
                        placeholder="Quantidade na Embalagem"
                        value={ this.state.qtddEmbalagem }
                        onChange={ this.changeQtddEmbalagem } /><br />
                    <ul class="edestoque-status-lst">
                        <li>
                            <b>Status: </b>
                            <label>
                                <input type="radio"
                                    name="ativo"
                                    value="ativo"
                                    checked={ this.state.ativo === true }
                                    onChange={ this.changeAtivo } /> Ativo
                            </label>
                            <label>
                                <input type="radio"
                                    name="ativo"
                                    value="inativo"
                                    checked={ this.state.ativo === false }
                                    onChange={ this.changeAtivo } /> Inativo
                            </label>
                        </li>
                    </ul>
                    <br /><br />
                    <button type="button" id="edproduto-cancelar-btn" onClick={ this.cancelar }>
                        Cancelar
                    </button>
                    <button type="button"
                        id="edproduto-salvar-btn"
                        onClick={ this.salvar }
                        disabled={ this.state.disabled }>Salvar</button>
                    <br /><br />
                </form>
            </div>
        );
    }

}

export default withRouter(EditarEstoque);

